import React from "react";
import { Navigate } from "react-router-dom";

//Dashboard
import KDashboard from "../pages/KDashboard";



//AuthenticationInner pages
import BasicSignIn from '../pages/AuthenticationInner/Login/BasicSignIn';
//pages
import AppSettings from '../pages/App Settings/appSettings';
import DateLogs from '../pages/Date Logs/dateLogs';
import MatchLogs from '../pages/Match Logs/matchLogs';
import SubscriptionPlans from '../pages/Subscription Plans/subscriptionPlans';
import Posts from '../pages/Posts/posts';
import LikeLogs from '../pages/Like Logs/likeLogs';
import AdminUsers from '../pages/Admin Users/adminUsers';
import TokenPlans from '../pages/Token Plans/tokenPlans';
import ReportedIssues from '../pages/Reported Issues/reportedIssues';
import ReviewRatings from '../pages/Review Ratings/reviewRatings';
import SmsLogs from '../pages/SMS Logs/smsLogs';
import EmailLogs from '../pages/Email Logs/emailLogs';
import UserMetadata from '../pages/User Matadata/userMetadata';
import VirtualGifts from '../pages/Virtual Gifts/virtualGifts';
import ModerateMedia from '../pages/Moderate Media/moderateMedia';
import Users from '../pages/Users/users';
import Gender from '../pages/Gender/gender';
import Language from '../pages/Language/language';
import Pronoun from '../pages/Pronoun/pronoun';
import FAQ from '../pages/FAQ/FAQ';
import FAQEdit from '../pages/FAQ/FAQEdit';
import Reasons from '../pages/Reasons/reasons';
import ReferralLogs from '../pages/Referral Logs/referralLogs';
import Privacypolicy from '../pages/Privacy Policy/privacypolicy';
import Terms from '../pages/Terms/terms';
import Maintenance from '../pages/Pages/Maintenance/Maintenance';
import ComingSoon from '../pages/Pages/ComingSoon/ComingSoon';

import BasicLockScreen from '../pages/AuthenticationInner/LockScreen/BasicLockScr';
import CoverLockScreen from '../pages/AuthenticationInner/LockScreen/CoverLockScr';
import BasicLogout from '../pages/AuthenticationInner/Logout/BasicLogout';
import CoverLogout from '../pages/AuthenticationInner/Logout/CoverLogout';
import BasicSuccessMsg from '../pages/AuthenticationInner/SuccessMessage/BasicSuccessMsg';
import CoverSuccessMsg from '../pages/AuthenticationInner/SuccessMessage/CoverSuccessMsg';
import BasicTwosVerify from '../pages/AuthenticationInner/TwoStepVerification/BasicTwosVerify';
import CoverTwosVerify from '../pages/AuthenticationInner/TwoStepVerification/CoverTwosVerify';
import Basic404 from '../pages/AuthenticationInner/Errors/Basic404';
import Cover404 from '../pages/AuthenticationInner/Errors/Cover404';
import Alt404 from '../pages/AuthenticationInner/Errors/Alt404';
import Error500 from '../pages/AuthenticationInner/Errors/Error500';

import BasicPasswCreate from "../pages/AuthenticationInner/PasswordCreate/BasicPasswCreate";
import CoverPasswCreate from "../pages/AuthenticationInner/PasswordCreate/CoverPasswCreate";
import Offlinepage from "../pages/AuthenticationInner/Errors/Offlinepage";

//login
import Login from "../pages/Authentication/Login";
import Logout from "../pages/Authentication/Logout";


import FAQAdd from '../pages/FAQ/FAQAdd';
import SubFAQs from '../pages/FAQ/SubFAQs';
import SubFAQEdit from '../pages/FAQ/SubFAQEdit';
import SubFAQAdd from '../pages/FAQ/SubFAQAdd';
import UserDetails from '../pages/Users/userDetails';

import Prompts from "../pages/Prompts/Prompts";

const authProtectedRoutes = [
  { path: "/dashboard", component: <KDashboard /> },
  { path: "/index", component: <KDashboard /> },

  

  //Pages
  { path: "/app-settings", component: <AppSettings /> },
  { path: "/date-logs", component: <DateLogs /> },
  { path: "/match-logs", component: <MatchLogs /> },
  { path: "/subscription-plans", component: <SubscriptionPlans /> },
  { path: "/posts", component: <Posts /> },
  { path: "/moderate-media", component: <ModerateMedia /> },
  { path: "/users", component: <Users /> },
  { path: "/like-logs", component: <LikeLogs /> },
  { path: "/admin-users", component: <AdminUsers /> },
  { path: "/token-plans", component: <TokenPlans /> },
  { path: "/reported-issues", component: <ReportedIssues /> },
  { path: "/review-and-ratings", component: <ReviewRatings /> },
  { path: "/sms-logs", component: <SmsLogs /> },
  { path: "/email-logs", component: <EmailLogs /> },
  { path: "/user-metadata", component: <UserMetadata /> },
  { path: "/virtual-gift", component: <VirtualGifts /> },
  { path: "/gender", component: <Gender /> },
  { path: "/language", component: <Language /> },
  { path: "/pronoun", component: <Pronoun /> },
  { path: "/faq-settings", component: <FAQ /> },
  { path: "/faq-edit/:id", component: <FAQEdit /> },
  { path: "/referral-logs", component: <ReferralLogs /> },
  { path: "/reasons", component: <Reasons /> },
  { path: "/privacy-policy", component: <Privacypolicy /> },
  { path: "/terms-of-service", component: <Terms /> },
  { path: "/prompts", component: <Prompts /> },


  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
  {
    path: "/",
    exact: true,
    component: <Navigate to="/dashboard" />,
  },
  { path: "*", component: <Navigate to="/dashboard" /> },

  { path: "/faq-add", component: <FAQAdd /> },
  { path: "/faq-subsections/:parentId", component: <SubFAQs /> },
  { path: "/subfaq-edit/:id", component: <SubFAQEdit /> },
  { path: "/subfaq-add/:parentId", component: <SubFAQAdd /> },
  { path: "/user-details/:userId/:tab", component: <UserDetails /> },
];

const publicRoutes = [
  // Authentication Page
  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <Login /> },

  //AuthenticationInner pages
  { path: "/auth-signin-basic", component: <BasicSignIn /> },
  { path: "/lockedscreen", component: <BasicLockScreen /> },
  { path: "/auth-lockscreen-cover", component: <CoverLockScreen /> },
  { path: "/auth-logout-basic", component: <BasicLogout /> },
  { path: "/auth-logout-cover", component: <CoverLogout /> },
  { path: "/auth-success-msg-basic", component: <BasicSuccessMsg /> },
  { path: "/auth-success-msg-cover", component: <CoverSuccessMsg /> },
  { path: "/auth-twostep-basic", component: <BasicTwosVerify /> },
  { path: "/auth-twostep-cover", component: <CoverTwosVerify /> },
  { path: "/auth-404-basic", component: <Basic404 /> },
  { path: "/auth-404-cover", component: <Cover404 /> },
  { path: "/auth-404-alt", component: <Alt404 /> },
  { path: "/auth-500", component: <Error500 /> },
  { path: "/pages-maintenance", component: <Maintenance /> },
  { path: "/pages-coming-soon", component: <ComingSoon /> },

  { path: "/auth-pass-change-basic", component: <BasicPasswCreate /> },
  { path: "/auth-pass-change-cover", component: <CoverPasswCreate /> },
  { path: "/auth-offline", component: <Offlinepage /> },

];

export { authProtectedRoutes, publicRoutes };